<template>
  <v-row>
    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalContact.cellularPhone"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalContact"
        @blur="$v.localPersonalContact.cellularPhone.$touch()"
        :error-messages="$errorMessages($v.localPersonalContact.cellularPhone)"
      >
        <template #label>
          <span class="required">Мобильный телефон</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalContact.homePhone"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalContact"
        @blur="$v.localPersonalContact.homePhone.$touch()"
        :error-messages="$errorMessages($v.localPersonalContact.homePhone)"
      >
        <template #label>
          <span>Домашний телефон</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-text-field
        v-model.trim="localPersonalContact.email"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalContact"
        @blur="$v.localPersonalContact.email.$touch()"
        :error-messages="$errorMessages($v.localPersonalContact.email)"
      >
        <template #label>
          <span class="required">Электронная почта</span>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import {PersonalContact} from "@/models";
import {personalContact} from "@/scripts/rules-validation";

export default {
  name: "ContactData",

  props: {
    personalContact: PersonalContact
  },

  data() {
    return {
      localPersonalContact: new PersonalContact()
    }
  },

  validations() {
    return {
      localPersonalContact: { ...personalContact }
    }
  },

  methods: {
    setPersonalContact() {
      this.$emit('set-personal-contact', this.localPersonalContact)
    }
  },

  watch: {
    'personalContact.id': {
      immediate: true,
      handler() {
        this.localPersonalContact = PersonalContact.build(this.personalContact)
      }
    },
  }
}
</script>

<style scoped>

</style>
